/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_ActiveInputs */

const en_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Active`)
};

const es_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo actual`)
};

const fr_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuellement actif`)
};

const de_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell aktiv`)
};

const ja_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在アクティブ`)
};

const zh_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前使用`)
};

const ar_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشط حالياً`)
};

const id_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif Saat Ini`)
};

const it_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attualmente Attivo`)
};

const ru_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий активный`)
};

const pt_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo Atual`)
};

const ko_current_active = /** @type {(inputs: Current_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 활성화됨`)
};

/**
* | output |
* | --- |
* | "Current Active" |
*
* @param {Current_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const current_active = /** @type {((inputs?: Current_ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_active(inputs)
	if (locale === "es") return es_current_active(inputs)
	if (locale === "fr") return fr_current_active(inputs)
	if (locale === "de") return de_current_active(inputs)
	if (locale === "ja") return ja_current_active(inputs)
	if (locale === "zh") return zh_current_active(inputs)
	if (locale === "ar") return ar_current_active(inputs)
	if (locale === "id") return id_current_active(inputs)
	if (locale === "it") return it_current_active(inputs)
	if (locale === "ru") return ru_current_active(inputs)
	if (locale === "pt") return pt_current_active(inputs)
	return ko_current_active(inputs)
});